import { render, staticRenderFns } from "./StudentsReleaseList.vue?vue&type=template&id=f2b070da&scoped=true&"
import script from "./StudentsReleaseList.vue?vue&type=script&lang=js&"
export * from "./StudentsReleaseList.vue?vue&type=script&lang=js&"
import style0 from "./StudentsReleaseList.vue?vue&type=style&index=0&id=f2b070da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b070da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/maplebear-pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VIcon})
